import { module } from "angular";
import favorites from "@gtmhub/favorites/favorites.module";
import hotkeys from "@gtmhub/shared/libs/angular-hotkeys/angular-hotkeys.module";
import { CloneOrMoveResourceService } from "@webapp/okrs/components/clone-move-okrs/clone-move-resource.service";
import { SessionConflictComponent } from "@webapp/sessions/components/session-conflict/session-conflict.component";
import { SessionOverviewComponent } from "@webapp/sessions/components/session-overview/session-overview.component";
import {
  ApprovalWorkflowSelectionFormComponent,
  ApprovalWorkflowSelectionModal,
} from "./components/approval-workflow-selection-form/approval-workflow-selection-form.component";
import { MethodologySectionComponent } from "./components/methodology-section/methodology-section.component";
import { SessionFormComponent, SessionFormCtrl } from "./components/session-form/session-form.component";
import { WorkflowSelectionAccordionComponent } from "./components/workflow-selection-accordion/workflow-selection-accordion.component";
import { CloneSessionsCtrl } from "./controllers/clone-sessions";
import { PlanningSessionConflictsCtrl } from "./controllers/conflicts";
import { InspectAssigneesWorkflowCtrl } from "./controllers/inspect-assignees-workflow";
import { InspectGoalsWorkflowCtrl } from "./controllers/inspect-goals-workflow";
import { InspectStatisticsCtrl } from "./controllers/inspect-statistics";
import { InspectWorkflowCtrl } from "./controllers/inspect-workflow";
import { NudgePeopleCtrl } from "./controllers/nudge-people";
import { PlanningSessionOverviewCtrl } from "./controllers/overview";
import { SessionSelectorCtrl } from "./controllers/session-selector";
import { PlanningSessionsCtrl } from "./controllers/sessions";
import { SessionsGanttChart } from "./directives/sessions-gantt-chart";
import { PlanningSessionSelector } from "./services/planning-session-selector";
import sessionsCore from "./sessions-core.module";

const mod = module("sessions", [sessionsCore, hotkeys, favorites]);

mod.controller("PlanningSessionsCtrl", PlanningSessionsCtrl);
mod.controller("CloneSessionsCtrl", CloneSessionsCtrl);
mod.controller("PlanningSessionConflictsCtrl", PlanningSessionConflictsCtrl);
mod.controller("SessionSelectorCtrl", SessionSelectorCtrl);
mod.controller("InspectAssigneesWorkflowCtrl", InspectAssigneesWorkflowCtrl);
mod.controller("InspectGoalsWorkflowCtrl", InspectGoalsWorkflowCtrl);
mod.controller("InspectStatisticsCtrl", InspectStatisticsCtrl);
mod.controller("InspectWorkflowCtrl", InspectWorkflowCtrl);
mod.controller("NudgePeopleCtrl", NudgePeopleCtrl);
mod.controller("PlanningSessionOverviewCtrl", PlanningSessionOverviewCtrl);
mod.component("approvalWorkflowSelectionForm", ApprovalWorkflowSelectionFormComponent);
mod.component("workflowSelectionAccordion", WorkflowSelectionAccordionComponent);
mod.service("PlanningSessionSelector", PlanningSessionSelector);
mod.service("ApprovalWorkflowSelectionModal", ApprovalWorkflowSelectionModal);

mod.directive("sessionsGanttChart", SessionsGanttChart.factory());
mod.downgradeComponent("sessionOverview", { component: SessionOverviewComponent, propagateDigest: false });
mod.downgradeComponent("sessionConflict", { component: SessionConflictComponent, propagateDigest: false });
mod.downgradeInjectable("CloneMoveResourceService", CloneOrMoveResourceService);

mod.component("sessionForm", SessionFormComponent);
// since we use the component in the state factory we need to register the controllers separately
mod.controller("SessionFormCtrl", SessionFormCtrl);
mod.component("methodologySection", MethodologySectionComponent);

export default mod.name;
